import config from "@/lib/config";
export default {
  401: "/401",
  404: "/404",
  geoRestriction: "/geo_restriction",
  home: "/",
  signUp: "/signup",
  signupStep: (step) => `/signup/step${step}`,
  subscriptionByRight: (id) => `/subscription/right/${id}`,
  svodPayment: (courseId) => `/subscription/${courseId}`,
  svodPaymentAfterSignUp: (courseId) => `/subscription/${courseId}?signup=1`,
  svodPaymentStep: (courseId, step) => `/subscription/${courseId}/step${step}`,
  svodPaymentStepAfterSignUp: (courseId, step) =>
    `/subscription/${courseId}/step${step}?signup=1`,
  subscriptionNotAllowed: "/subscription/notallowed",
  subscriptionContracted: "/subscription/contracted",
  signupComplete: "/signup/complete",
  login: "/login",
  spooxCooperation: "/spooxcooperation",
  loginspoox: "/loginspoox",
  idccallback: "/idc/callback",
  logout: "/logout",
  passwordRemind: "/password_remind",
  passwordRemindReset: "/password_remind/reset",
  profilePincodeReset: "/profile_pincode_reset",
  restricted: "/restricted",
  title: (id) => `/title/${id}`,
  titleWithRtsid: (item) => {
    if (item?.rtsid) {
      return `/title/${item.id}?rtsid=${item.rtsid}`;
    } else {
      return `/title/${item.id}`;
    }
  },
  titleEpisodes: (id) => `/title/${id}#episodes`,
  titleRecommend: (id) => `/title/${id}#recommend`,
  channels: "/channels",
  channelDetail: (id, hash) => {
    if (hash) {
      return `/channels/${id}#${hash}`;
    } else {
      return `/channels/${id}`;
    }
  },
  channelDetailSearch: (id, query) =>
    `/channels/${id}/search?q=${encodeURIComponent(query)}`,
  channelDetailSearchOnair: (id, query) =>
    `/channels/${id}/search/onair?q=${encodeURIComponent(query)}`,
  channelDetailSearchBefore: (id, query) =>
    `/channels/${id}/search/before?q=${encodeURIComponent(query)}`,
  channelDetailSearchCatchup: (id, query) =>
    `/channels/${id}/search/catchup?q=${encodeURIComponent(query)}`,
  channelDetailSearchVideo: (id, query) =>
    `/channels/${id}/search/video?q=${encodeURIComponent(query)}`,
  channelDetailFeatured: (id) => `/channels/${id}/featured`,
  channelsEntitled: "/channels#entitled",
  channelsUnentitled: "/channels#unentitled",
  valuePlan: "/valueplan",
  valuePlanDiscountDetail: "/static/sales/campaign/valueplan_with_kihon",
  valuePlanCampaignDetail: "/static/sales/campaign/valueplan90",
  store: "/store",
  myList: "/mylist",
  myListFavorites: "/mylist#favorites",
  myListValuePlan: "/mylist#valueplan",
  myListLive: "/mylist/favorites/live",
  myListEpisode: "/mylist/favorites/episode",
  myListTvShow: "/mylist/favorites/tvshow",
  myListChannel: "/mylist/favorites/channel",
  myListSubscription: "/mylist#subscription",
  myListRental: "/mylist#rental",
  myListWatchHistory: "/mylist#watchhistory",
  profileAdd: "/profiles/add",
  profileEdit: (id) => `/profiles/edit/${id}`,
  profileSwitch: (prev) =>
    prev ? "/profiles/switch?prev=1" : "/profiles/switch",
  tvodPayment: (productId) => `/purchase/${productId}`,
  tvodPaymentAfterSignUp: (productId) => `/purchase/${productId}?signup=1`,
  tvodPaymentStep: (productId, step) => `/purchase/${productId}/step${step}`,
  tvodPaymentStepAfterSignUp: (productId, step) =>
    `/purchase/${productId}/step${step}?signup=1`,
  productPurchased: "/purchase/purchased_error",
  purchaseError: "/purchase/error",
  sbpsSuccess: "/relation/success",
  sbpsError: "/relation/error",
  sbps3dsSuccess: "/relation/success_3ds",
  sbps3dsError: "/relation/error_3ds",
  sbps3dsErrorWithId: (paymentInstrumentId) =>
    "/relation/error_3ds?id=" + paymentInstrumentId,

  watch: (id) => `/watch/${id}`,
  watchWithRtsid: (item) => {
    if (item?.rtsid) {
      return `/watch/${item.id}?rtsid=${item.rtsid}`;
    } else {
      return `/watch/${item.id}`;
    }
  },
  account: "/account",
  accountProduct: "/account#product",
  accountPaymentMethod: "/account#paymentmethod",
  accountPaymentHistory: "/account#paymenthistory",
  accountAddPayment: "/account/addpayment",
  accountChangeSvodPayment: (subscriptionId) =>
    `/account/subscription_payment/${subscriptionId}`,
  palette: (id) => `/palette/${id}`,
  unsubscribe: (courseId) => `/account/unsubscribe/${courseId}`,
  unsubscribeStep: (courseId, step) =>
    `/account/unsubscribe/${courseId}/step${step}`,
  unsubscribeNoContract: "/account/unsubscribe/nocontract",
  unsubscribeError: "/account/unsubscribe/error",
  withdraw: "/account/withdraw",
  withdrawInvoke: "/account/withdraw/invoke",
  withdrawComplete: "/account/withdraw/complete",
  withdrawForbidden: "/account/withdraw/forbidden",
  withdrawError: "/account/withdraw/error",
  inquiry: "/inquiry",
  inquiryStep: (step) => `/inquiry/step${step}`,
  search: (query, path) => {
    if (path) {
      return `/search/${path}?q=${encodeURIComponent(query)}`;
    } else {
      return `/search?q=${encodeURIComponent(query)}`;
    }
  },
  informations: "/informations",
  // campaignWithBroadcast: "/static/sales/campaign/with_broadcast",
  environment: "/static/feature/constant/environment",
  legalSctLaw: "/static/legal/sct_law",
  canvas: (slug) => `/canvas/${slug}`,
  mailOption: "/account/mail_option",
  timeOut: "/timeout",
};
